import getEvenOddByIndex from '../../../../functions/getEvenOddByIndex'
import SortableWrapperContainer from '../../../../containers/dnd/SortableWrapperContainer'
import Translation from '../../../Translation/cont/Translation'

const SortableList = ({
    className = '',
    label = '',
    order = [],
    items = {},
    itemOptions = [],
    dndType='sortable-list',
    onReorderItem
}) => {

    return (
        <div className={"sortable-list"  + (className ? ' ' + className : '')}>
            {label && <label className='field-text-label'>{label}</label>}

            <ul className="list">
                {order.map((itemId, index) => (
                    <SortableWrapperContainer
                        key={itemId}
                        index={index} 
                        moveItem={onReorderItem} 
                        dndType={dndType}
                    >
                        <li className={"list-item list-item-grid " + getEvenOddByIndex(index)}>
                            {itemOptions.map((option, i) => (
                                <div key={'item-' + i} className={getEvenOddByIndex(i)}>
                                    {'button' === option.type ? (
                                        <div 
                                            className={'icon cursor-pointer button button-icon button-' + option.action}
                                            { ... option.hasOwnProperty('onClick') ? {onClick: () => option.onClick(index)} : null}
                                        />
                                    ) : 'text' === option.type ? (
                                        <div className="text">{items[itemId][option.key]}</div>
                                    ) : 'translation' === option.type ? (
                                        <div className="text"><Translation id={items[itemId][option.key]} /></div>
                                    ) : ''}
                                </div>
                            ))}
                        </li>
                    </SortableWrapperContainer>
                ))}
            </ul>
        </div>
    )
}

export default SortableList

